import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../../components/ad/ad';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import AllFeed from '../../../../components/all_feed/all_feed';
import PersonCompanyComponent from '../../../../components/person_company_component/person_company_component';
import { tagAllFeedAllStoriesRendered } from '../../../../../redux/action_creators/tag/tag_all_feed_action_creators';
import loadData from './person_page_state_manager';
import { canUseDOM } from 'exenv';

// eslint-disable-next-line react/prefer-stateless-function
class Person extends Component {
  static loadData(store) {
    return loadData(store);
  }

  componentDidMount() {
    const adData = get(this.props.personPage, 'ads');

    if (canUseDOM) {
      // Update the data layer
      if (adData !== undefined) {
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  render() {
    const { status, config, personPage, person, tagAllFeed } = this.props;

    if (status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (personPage.isLoading) {
      return (
        <section className="person-page">
          <article className="person-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(personPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const fullName = `${get(person, 'first_name')} ${get(person, 'last_name')}`;

    return (
      <section className="person-page">
        <Ad
          {...combinedAdModel}
          name="mobileleaderboard_short"
          region="articletop"
          pos="atf"
        />
        <Ad {...combinedAdModel} name="oop" slug={false} oop />
        <PersonCompanyComponent personOrCompany={person} type="person" />
        <div className="person-page__ad-container">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_1"
            noLazyLoad={true}
          />
          <Ad {...combinedAdModel} name="mobilerectangle_1" noLazyLoad={true} />
        </div>

        {get(tagAllFeed, 'posts[0]') ? (
          <AllFeed
            adModel={combinedAdModel}
            stories={get(tagAllFeed, 'posts')}
            allRendered={true}
            updateAction={tagAllFeedAllStoriesRendered}
            config={config}
            titleOverride={`Stories about ${fullName}`}
          />
        ) : (
          ''
        )}
        {get(this.props, 'tagAllFeed.posts[0]') ? (
          <div className="person-page__ad-container">
            <Ad
              {...combinedAdModel}
              name="flexiblebillboard_1"
              noLazyLoad={true}
            />
            <Ad
              {...combinedAdModel}
              name="mobilerectangle_1"
              noLazyLoad={true}
            />
          </div>
        ) : (
          ''
        )}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    person: get(state, 'person.data.rows[0]') || { error: true },
    personPage: get(state, 'personPage') || { error: true },
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Person.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number.isRequired,
  person: PropTypes.shape({}).isRequired,
  personPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagAllFeed: PropTypes.shape({
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number,
    allRendered: PropTypes.bool,
    posts: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};

export default connect(mapStateToProps)(Person);
